const getAdditionalContext = async (graphql, locale) => {
  const { data } = await graphql(`
    fragment internalLinkFields on LinkValue {
      ... on SanityPage {
        id: _id
        _type
        slug {
          current
        }
      }
      ... on SanitySharedPage {
        id: _id
        _type
        slug {
          current
        }
      }
      ... on SanityBlogPost {
        id: _id
        _type
        slug {
          current
        }
      }
      ... on SanityBlogCategory {
        id: _id
        _type
        slug {
          current
        }
      }
      ... on SanityPressRelease {
        id: _id
        _type
        slug {
          current
        }
      }
      ... on SanityPerson {
        id: _id
        _type
        slug {
          current
        }
      }
      ... on SanityGlobalProduct {
        id: _id
        _type
        store {
          slug {
            current
          }
        }
      }
      ... on SanityGlobalProductCollection {
        id: _id
        _type
        store {
          title
          slug {
            current
          }
        }
      }
    }
      query {
        allSanitySiteSettings(
          filter: { 
            _type: { eq: "siteSettings" }, 
            siteIdentifier: { eq: "petsafe" }
          }
        ) {
          nodes {
            language
            notificationBannerCarousel {
              notificationBannerItems {
                _key
                blockSvg {
                  linkType
                  svgUploaded {
                    alt
                    asset {
                      url
                    }
                  }
                }
                block: _rawLocalizedBody(resolveReferences: { maxDepth: 10, referenceMaxDepth: 1 }, language: "${locale}")
              }
              _key
            }
            footerCustomColumns: _rawLocalizedFooterCustomColumns(
              resolveReferences: { maxDepth: 10, referenceMaxDepth: 1 }, language: "${locale}"
            )
            footerLegal: _rawLocalizedFooterLegal(
              resolveReferences: { maxDepth: 10, referenceMaxDepth: 1 }, language: "${locale}"
            )
            mainMenu {
              title
              menuType
              isGallery
              ctaText
              _key
              items {
                ... on SanityMenuItemMegaMenuItem {
                  _key
                  title
                  menuItemSupportChat
                  link {
                    #SanityLinkNoCaption
                    linkType
                    href
                    blank
                    internalLink: localizedInternalLinkValue(locale: "${locale}") {
                      ...internalLinkFields
                    }
                  }
                }
              }
              collection: localizedCollectionValue(locale: "${locale}") {
                ... on SanityGlobalProductCollection {
                  language
                  store {
                    title
                    slug {
                      current
                    }
                  }
                  navChildCollectionsOrder {
                    language
                    store {
                      title
                      slug {
                        current
                      }
                    }
                    navChildCollectionsOrder {
                      language
                      store {
                        title
                        slug {
                          current
                        }
                      }
                    }
                  }
                }
                navMoment {
                  headline
                  link {
                    linkType
                    href
                    blank
                    internalLink: localizedInternalLinkValue(locale: "${locale}") {
                      ...internalLinkFields
                    }
                  }
                  image {
                    asset {
                      _id
                      url
                    }
                    alt
                    hotspot {
                      x
                      y
                    }
                  }
                  mediaType
                  video {
                    url
                    thumbnail
                  }
                }
              }
              link {
                #SanityLinkNoCaption
                linkType
                href
                blank
                internalLink: localizedInternalLinkValue(locale: "${locale}") {
                  ...internalLinkFields
                }
              }
              moments {
                headline
                link {
                  linkType
                  href
                  blank
                  internalLink: localizedInternalLinkValue(locale: "${locale}") {
                    ...internalLinkFields
                  }
                }
                image {
                  asset {
                    _id
                    url
                  }
                  alt
                  hotspot {
                    x
                    y
                  }
                }
                mediaType
                video {
                  url
                  thumbnail
                }
              }
              mobileImage {
                alt
                asset {
                  _id
                  url
                }
                hotspot {
                  x
                  y
                }
              }
            }
          }
        }
      }
    `);

  const fallbackSanitySiteSettings = data.allSanitySiteSettings.nodes[0];
  const sanitySiteSettings = locale
    ? data.allSanitySiteSettings.nodes.find(s => s.language === locale) ??
      fallbackSanitySiteSettings
    : fallbackSanitySiteSettings;

  return {
    mainMenu: sanitySiteSettings.mainMenu,
    notificationBannerCarousel: sanitySiteSettings.notificationBannerCarousel,
    footerCustomColumns: sanitySiteSettings.footerCustomColumns,
    footerLegal: sanitySiteSettings.footerLegal,
  };
};

module.exports = {
  getAdditionalContext,
};
